import HeadData from 'components/Common/HeadData'
import { useIntl } from 'react-intl'
import config from 'constants/config'

function CruiseDestinationsHeadData(props: { destination: string }) {
  const intl = useIntl()
  const { destination } = props
  const currentYear = new Date().getFullYear()
  const title = intl.formatMessage(
    {
      id: 'LerQp4CuU_NOPgm_ycjK',
      defaultMessage: 'Cruises to {destination} | Best Deals {currentYear} - {nextYear}',
      description: 'SEO page title for cruise destination landing page',
    },
    { destination, currentYear, nextYear: currentYear + 1 },
  )
  const description = intl.formatMessage(
    {
      id: 'C5kDg3aqAMWmB9DY1Ghr',
      defaultMessage: 'Embark on a cruise to {destination} with {brandName}. Browse our wide variety of exclusive deals and curated extras to make your cruise unforgettable.',
      description: 'SEO meta description for cruise destination landing page with the current brand name',
    },
    { brandName: config.brandConfig.name, destination },
  )

  return <HeadData title={title} description={description} />
}

export default CruiseDestinationsHeadData
